import { BaseBus } from "./BaseBus";
export class v_QuoteDetailBus extends BaseBus
{
  constructor(data: v_QuoteDetailBus = null)
  {
      super(data);
      //{
      //  this.quoteId = data.quoteId;
      //  this.locationName = data.locationName;
      //  this.quickSearchKey = data.quickSearchKey;
      //  this.acctManName = data.acctManName;
      //  this.acctManMainNumber = data.acctManMainNumber;
      //  this.acctManCellNumber = data.acctManCellNumber;
      //  this.customerName = data.customerName;
      //  this.phone = data.phone;
      //  this.addressLine1 = data.addressLine1;
      //  this.addressLine2 = data.addressLine2;
      //  this.city = data.city;
      //  this.stateProvince = data.stateProvince;
      //  this.postalCode = data.postalCode;
      //  this.coNo = data.coNo;
      //  this.coName = data.coName;
      //  this.coAddressLine1 = data.addressLine1;
      //  this.coCity = data.coCity;
      //  this.coStateProvince = data.coStateProvince;
      //  this.coPostalCode = data.coPostalCode;
      //  this.coWorkNumber = data.coWorkNumber;
      //  this.coEmailAddress = data.coEmailAddress;
      //  this.coLogo = data.coLogo;
      //  this.coLogoString = data.coLogoString;
      //  this.coFaxNumber = data.coFaxNumber;
      //    this.billingAddressLine1 = data.billingAddressLine1;
      //    this.billingAddressLine2 = data.billingAddressLine2;
      //    this.billingCity = data.billingCity;
      //    this.billingStateProvince = data.billingStateProvince;
      //    this.billingPostalCode = data.billingPostalCode;
      //    this.dispatchNumber = data.dispatchNumber;
      //    this.dispatchDate = new Date(data.dispatchDate);
      //    this.callbackNumber = data.callbackNumber;
      //    this.invoiceNumber = data.invoiceNumber;
      //    this.billingLocationName = data.billingLocationName;
      //}
    }
    protected setAdditional(busObj: any) {
        if (busObj.dispatchDate !== undefined && busObj.dispatchDate !== null) {
            this.dispatchDate = new Date(busObj.dispatchDate);
        }
    }
  quoteId: any;
  locationName: string;
  quickSearchKey: string;
  acctManName: string;
  acctManMainNumber: string;
  acctManCellNumber: string;
  customerName: string;
  phone: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  coNo: number;
  coName: string;
  coAddressLine1: string;
  coCity: string;
  coStateProvince: string;
  coPostalCode: string;
  coWorkNumber: string;
  coEmailAddress: string;
  coLogo: any[];
  coFaxNumber: string;
  coLogoString: string;
    billingLocationName: string;
    billingAddressLine1: string;
    billingAddressLine2: string;
    billingCity: string;
    billingStateProvince: string;
    billingPostalCode: string;
    dispatchNumber: string;
    dispatchDate: Date;
    callbackNumber: string;
    invoiceNumber: string;
    taxAmount: number;
    relatedJobTypeId: any;

  get address() : string {
    let temp = !BaseBus.strIsEmpty(this.addressLine1) && !BaseBus.strIsEmpty(this.addressLine2)
              ? this.addressLine1 + " " + this.addressLine2
              : this.addressLine1;
    return temp;
  }
  get cityStateZip() : string {
    return this.city + ", " + this.stateProvince + " " + this.postalCode;
  }
  get coCityStateZip(): string {
    return this.coCity + ", " + this.coStateProvince + " " + this.coPostalCode;
  }

}
